import { render, staticRenderFns } from "./EscorterAddEditModal.vue?vue&type=template&id=12df2dcd"
import script from "./EscorterAddEditModal.vue?vue&type=script&lang=js"
export * from "./EscorterAddEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports